import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';

const App = () => {
	console.log = () => {};

	return (
		<>
			<Router>
				<Routes>
					<Route path='/:key' element={<Home />} />
					{/* <Route path='/' element={<Home />} /> */}
				</Routes>
			</Router>
		</>
	);
};

export default App;
